<template>
  <div ref="dropdown" class="language-dropdown">
    <button
        class="language-dropdown__btn flex ttc btn btn--text items-center bg-transparent"
        :class="{'active_selector': selectorActive}"
        style="margin-left: auto"
        @click="handleLanguageDropdownClick"
    >
      {{selectedLanguage.name}}
      <span class="fw3 moon-gray">|</span>
      <img :src="selectedLanguage.flag" alt>
    </button>

    <ul
        class="language-dropdown__list"
        :class="dropClass"
        @keydown.esc="handleClose"
        @blur="handleClose"
    >
      <li v-for="language in languages" :key="language.language">
        <span>
          <img :src="language.flag" alt>
          <a
              @click="handleClose(language.language)"
              :id="language.title"
              class="link"
              :class="{'language-selected': (getLanguage() === language.language)}"
              href="#"
          >{{language.title}}</a>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getLanguage, getPathNameFromRouteName } from '@/utils/common';

export default {
  data() {
    return {
      selectorActive: false,
      languageDropdownVisible: false,
      dropClass: 'hidden',
      languages: [
        { flag: '/static/images/uk.svg', language: 'en-us', title: 'EN' },
        {
          flag: '/static/images/france.svg',
          language: 'fr',
          title: 'FR'
        },
        { flag: '/static/images/italy.svg', language: 'it', title: 'IT' },
        { flag: '/static/images/japan.svg', language: 'ja', title: 'JA' },
        { flag: '/static/images/brazil.svg', language: 'pt', title: 'PT' },
        { flag: '/static/images/spain.svg', language: 'es', title: 'ES' }
      ]
    };
  },
  computed: {
    selectedLanguage() {
      let selectedLanguageObject = this.languages.find(language => {
        return getLanguage() === language.language;
      });
      return { name: selectedLanguageObject.title, flag: selectedLanguageObject.flag };
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    getLanguage: getLanguage,
    handleClose(language) {
      let originalLocation = window.location.href;
      /* eslint-disable no-useless-escape */
      let regex = new RegExp(`\/${getLanguage()}`, 'g');
      this.changeLanguage(language).then(() => {
        let redirectPathName = `${getPathNameFromRouteName(this.$route.name, this.$router)}${window.location.search}`;
        if (redirectPathName) {
          window.location.href = `/${language}/${redirectPathName.replace(/ /g, '-')}`;
        } else {
          window.location.href = originalLocation.replace(regex, `/${language}`);
        }
      });
    },
    toggleOpenState() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
      if (this.dropClass === 'shown') {
        return (this.dropClass = 'hidden');
      }
      this.dropClass = 'shown';
    },
    handleLanguageDropdownClick() {
      this.selectorActive = !this.selectorActive;
      this.toggleOpenState();
    },
    domain() {
      return this.$store.state.siteDetails.domain_name;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

li span img,
.language-dropdown button img {
  position: absolute;
  height: 35px;
  width: 50px;
  padding-left: 5px;
  padding-bottom: 5px;
  padding-top: 9px;
  right: 10px;
  box-sizing: border-box;
}
.language-dropdown {
  position: relative;
  z-index: 2;
}

.hidden,
ul.hidden {
  max-height: 0px;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  border-bottom: none;
}

ul.shown,
.shown {
  max-height: 2000px;
  border-bottom: 2px solid #666;
  transition: max-height 0.5s ease-in-out;
}

.language-dropdown__btn {
  outline: none;
  position: relative;
  display: inline-block;
  width: 90px;
  line-height: 39px;
  padding: 0 10px;
  cursor: pointer;
  text-align: left;
  padding-left: 15px;
  border-radius: 30px;
  color: #FFF;
  box-sizing: border-box;
  transition: border-radius 0.2s;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
}
.language-dropdown__list {
  overflow: hidden;
  max-height: 0px;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  // display: none;

  position: absolute;
  width: 90px;
  border-top: 0px;
  outline: 0;
  z-index: 3;
  margin: 0 30px 0 0;
  list-style-type: none;
  padding: 0;
  background-color: #FFF;
  font-weight: 400;
  line-height: 1.5;
  color: #000;
  font-size: 100%;
  .text {
    margin: 0;
    padding: 0.2rem;
    font-weight: 600;
    color: #000;
    font-size: 0.9rem;
  }

  .link {
    height: 39px;
    line-height: 39px;
    text-align: left;
    padding-left: 15px;
    position: relative;
    text-transform: capitalize;
    box-sizing: inherit;
    color: #000;
    font-size: 14px;
    cursor: pointer;
    list-style-type: none;
  }
  .text,
  .link {
    display: block;
    margin-bottom: 0.02rem;
  }
}

.language-selected {
  font-weight: 600 !important;
}
.active_selector {
  border-radius: 30px 30px 0 0 !important;
}
</style>
